import React, { Component } from "react"
import "./chip.sass"
let classNames = require("classnames")
class ChipGroup extends Component {
  handleChipChange = data => {
    let currentChips = this.props?.selectedChips?.length > 0 ? [...this.props.selectedChips] : []
    if (data.checked) {
      currentChips.push(data.value)
    } else {
      let index = currentChips.indexOf(data.value)
      if (index > -1) {
        currentChips.splice(index, 1)
      }
    }
    let uniqChips = currentChips.reduce(function(a, b) {
      if (a.indexOf(b) < 0) a.push(b)
      return a
    }, [])
    this.props.onChange(uniqChips)
  }

  canDisableBikeCategoriesChip = (value) => {
    let currentChips = this.props?.selectedChips?.length > 0 ? [...this.props.selectedChips] : []
    if ((currentChips.length == 0) || value === 'all_styles' && currentChips.includes(value)) {
      return false
    } else if (currentChips.length > 0 && !currentChips.includes('all_styles') && value != 'all_styles') {
      return false
    } else {
      return true
    }
  }

  render() {
    /*let filterBtnClass = classNames('filterBtnClass', this.props.className, {
            'filter-active': active,
            'filter-open' :  open
        });*/

    const { chipData, labelKey, valueKey, iconKey, chipType, disableAllStyle } = this.props
    const missingRequirements =
      this.props.labelKey && this.props.valueKey ? false : true
    return (
      <React.Fragment>
        {missingRequirements && (
          <div className="tags has-text-centered">
            Chip Group missing props.
          </div>
        )}

        {!missingRequirements && (
          <div className="tags has-text-centered is-centered">
            {chipData.map((chip, index) => {
              let value = chip[valueKey]
              let checked = this.props.selectedChips?.includes(chip[valueKey])
              let label = (
                <>
                  <span className="icon">
                    <i className={`${!checked ? 'fal fa-plus' : 'fas fa-check'}`}></i>
                  </span>
                      {iconKey && chip[iconKey] && <img className="chip-icon invert-color" src={chip[iconKey]}/>}
                      {chip[labelKey]}
                </>
              )

              let chipClass = classNames(
                "tag is-rounded chip-check-tag is-medium",
                this.props.className,
                {
                  "is-primary is-chip-selected": checked
                }
              )

              return (
                <button
                  className={chipClass}
                  key={index}
                  onClick={(e) =>{
                    e.preventDefault()
                    this.handleChipChange({
                      value: value,
                      checked: checked ? false : true
                    })
                  }}
                  disabled={
                    (disableAllStyle && chip[valueKey] == 'all_styles') ||
                    (chipType == 'bikeCategories' && this.canDisableBikeCategoriesChip(value))
                  }
                >
                  {label}
                </button>
              )
            })}
          </div>
        )}
      </React.Fragment>
    )
  }
}

export default ChipGroup

ChipGroup.defaultProps = {
  chipData: {},
  labelKey: null,
  valueKey: null,
  selectedChips: [],
  onChange: function() {}
}
